import React from 'react';
import { FadeIn } from './FadeIn';

export default function EditorialBlocks() {
  return (
    <section className="bg-aged-ivory py-24 md:py-32 lg:py-48 px-6 overflow-hidden">
      <div className="max-w-[1440px] mx-auto space-y-32 md:space-y-48 lg:space-y-64">
        {/* Investment & Value - Responsive Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          <FadeIn direction="right" className="relative order-2 lg:order-1">
            <div className="relative group">
              <div className="aspect-[4/5] sm:aspect-square rounded-[32px] overflow-hidden shadow-2xl">
                <img 
                  src="https://ik.imagekit.io/aeu02xvjgn/Ad%20Images/01-details%20padua%20hills%20theatre-179.jpg?updatedAt=1778006781445" 
                  alt="Intricate Architecture" 
                  className="w-full h-full object-cover transition-transform duration-[3000ms] group-hover:scale-105" 
                  loading="lazy" 
                />
              </div>
              {/* Floating Badge - Desktop Only */}
              <div className="absolute -bottom-10 -right-10 bg-estate-bronze p-10 text-vintage-white rounded-3xl shadow-2xl max-w-xs hidden xl:block translate-y-4 group-hover:translate-y-0 transition-transform duration-700">
                <p className="font-serif text-2xl italic mb-4">"A legacy of elegance."</p>
                <p className="text-xs font-light leading-relaxed opacity-80 tracking-wider">
                  From hand-carved details to historic masonry, every corner of Padua tells a unique story.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" className="order-1 lg:order-2 lg:pl-10">
            <span className="uppercase tracking-[0.5em] text-estate-bronze text-[10px] font-bold mb-6 block">
              Investment & Value
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-7xl text-deep-charcoal mb-8 leading-[1.1] text-balance">
              Honest Estimates,<br />Personalized to You.
            </h2>
            <p className="text-lg md:text-xl leading-relaxed text-deep-charcoal/70 font-light mb-10 max-w-xl">
              We believe in transparency from the very first meeting. During your visit, we’ll build a vision together so you leave with a clear understanding of your wedding investment—no guesswork, just clarity.
            </p>
            <div className="flex items-center gap-6 text-estate-bronze font-bold tracking-[0.3em] text-[10px] uppercase">
              <span className="w-16 h-px bg-estate-bronze/40"></span>
              The Padua Promise
            </div>
          </FadeIn>
        </div>

        {/* Heritage Section - Visual Showcase */}
        <div className="relative">
          <FadeIn className="text-center mb-16 md:mb-24">
            <span className="uppercase tracking-[0.5em] text-estate-bronze text-[10px] font-bold mb-6 block">
              Our Heritage
            </span>
            <h2 className="text-4xl md:text-6xl lg:text-8xl text-deep-charcoal mb-8">Established 1931</h2>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12">
            <FadeIn className="md:col-span-8 h-[450px] md:h-[600px] lg:h-[700px]">
              <div className="w-full h-full rounded-[40px] overflow-hidden shadow-2xl group">
                <img 
                  src="https://ik.imagekit.io/aeu02xvjgn/Updated%20images/ChatGPT%20Image%20May%202,%202026,%2007_26_10%20PM.png?updatedAt=1777937947625" 
                  className="w-full h-full object-cover transition-transform duration-[4000ms] group-hover:scale-110" 
                  alt="Spanish Revival Heritage" 
                  loading="lazy" 
                />
              </div>
            </FadeIn>

            <FadeIn delay={0.2} className="md:col-span-4 h-auto min-h-[350px] md:h-[600px] lg:h-[700px]">
              <div className="bg-deep-charcoal w-full h-full rounded-[40px] p-10 md:p-14 flex flex-col justify-end text-vintage-white shadow-2xl relative overflow-hidden">
                {/* 
                  REMOVED: The absolute positioned SVG triangle artifact 
                  that was previously here.
                */}
                <p className="text-2xl md:text-3xl font-serif italic mb-6">A Claremont Landmark</p>
                <p className="text-base md:text-lg font-light leading-relaxed text-aged-ivory/60">
                  Defined by Spanish Revival architecture, centuries-old olive groves, and a century of celebrated unions.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  );
}